import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    accountHolder: 'Legal representative',
    accountHolderError:
      'Please select one of the beneficiaries as the representative',
    accountHolderHint:
      'One person is already an account holder. Remove them this right first.',
    accountHolderLabel:
      'This person will be the legal representative and will have access to the account',
    delete: 'Delete',
    directorDescription: {
      future:
        'They will legally represent the company or have a mandate as Président or Gérant.',
      present:
        'They legally represent the company or have a mandate as Président or Gérant.',
    },
    directorLabel: {
      future: 'Will they be a director of the company?',
      present: 'Are they a director of the company?',
    },
    edit: 'Edit',
    invalidMessage:
      'If they are neither a director nor a shareholder of at least 25% of the company’s shares, this means that they are not one of the beneficial owners. Please check your answers, or delete this person.',
    invalidWithSharesMessage:
      'If they are neither a director nor a shareholder, this means that they are not one of the beneficial owners. Please check your answers, or delete this person.',
    inviteeEmail: 'Email Address',
    majorShareholderDescription: {
      future:
        'They will be a shareholder of 25% or more of the company’s shares, directly or not.',
      present:
        'They are a shareholder of 25% or more of the company’s shares, directly or not.',
    },
    majorShareholderLabel: {
      future: 'Will they have 25% or more of the company’s shares?',
      present: 'Do they have 25% or more of the company’s shares?',
    },
    missingInfo: 'Please add their information',
    modify: 'Edit',
    no: 'No',
    save: 'Save',
    shareholderDescription: 'Shareholder, directly or not.',
    shareholderLabel: {
      future: 'Will they have shares in the company?',
      present: 'Do they have shares in the company?',
    },
    yes: 'Yes',
  },
  fr: {
    accountHolder: 'Représentant•e légal•e',
    accountHolderError:
      'Veuillez choisir un des bénéficiaires comme représentant•e',
    accountHolderHint: 'Une personne est déjà titulaire. Retirez lui ce droit.',
    accountHolderLabel:
      'Cette personne sera la•le représentant•e légal•e et aura accès au compte',
    delete: 'Supprimer',
    directorDescription: {
      future:
        'Représentera légalement l’entreprise ou disposera d’un mandat de président ou gérant.',
      present:
        'Représente légalement l’entreprise ou dispose d’un mandat de président ou gérant.',
    },
    directorLabel: {
      future: 'Sera-t-il·elle un·e dirigeant·e de l’entreprise\u00A0?',
      present: 'Est-il·elle un·e dirigeant·e de l’entreprise\u00A0?',
    },
    edit: 'Éditer',
    invalidMessage:
      'Si cette personne n’est ni dirigeante ni actionnaire d’au moins 25\u00A0% des parts de l’entreprise le·la signifie qu’elle ne fait pas partie des bénéficiaires effectifs. Veuillez vérifier vos réponses, ou supprimer cette personne.',
    invalidWithSharesMessage:
      'Si cette personne n’est ni dirigeante ni actionnaire de l’entreprise cela signifie qu’elle ne fait pas partie des bénéficiaires effectifs. Veuillez vérifier vos réponses, ou supprimer cette personne.',
    inviteeEmail: 'Adresse e-mail',
    majorShareholderDescription: {
      future:
        'Il·Elle sera actionnaire à hauteur de 25\u00A0% ou plus des parts de l’entreprise, directement ou non.',
      present:
        'Il·Elle est actionnaire à hauteur de 25\u00A0% ou plus des parts de l’entreprise, directement ou non.',
    },
    majorShareholderLabel: {
      future:
        'Aura-t-il·elle 25\u00A0% ou plus des parts de l’entreprise\u00A0?',
      present: 'A-t-il·elle 25\u00A0% ou plus des parts de l’entreprise\u00A0?',
    },
    missingInfo: 'Veuillez compléter ses informations',
    modify: 'Modifier',
    no: 'Non',
    save: 'Sauvegarder',
    shareholderDescription: 'Actionnaire, directement ou non.',
    shareholderLabel: {
      future: 'Aura-t-il·elle des parts dans l’entreprise\u00A0?',
      present: 'A-t-il·elle des parts dans l’entreprise\u00A0?',
    },
    yes: 'Oui',
  },
} as const);
